__turbopack_context__.v({
  "card-text-grid": "sJ2Ibq_card-text-grid",
  "carousel-item-quote": "sJ2Ibq_carousel-item-quote",
  "carousel-item-title": "sJ2Ibq_carousel-item-title",
  "flat-carousel-wrapper": "sJ2Ibq_flat-carousel-wrapper",
  "fullbg-content": "sJ2Ibq_fullbg-content",
  "image": "sJ2Ibq_image",
  "image-container": "sJ2Ibq_image-container",
  "slideInFromLeft": "sJ2Ibq_slideInFromLeft",
  "text-container": "sJ2Ibq_text-container",
});
